/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

/**
 * Minimal single-color speaker icon for the background-video audio toggle.
 * `on` draws a couple of sound waves; `off` draws a slash through the speaker.
 * Uses `currentColor` so the button controls its color.
 */

interface SoundIconProps {
  on: boolean;
  size?: number;
}

function SoundIcon({ on, size = 18 }: SoundIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M4 9v6h4l5 4V5L8 9H4z" />
      {on ? (
        <>
          <path d="M16 9a4 4 0 0 1 0 6" />
          <path d="M18.5 6.5a7.5 7.5 0 0 1 0 11" />
        </>
      ) : (
        <path d="M17 9.5l4 5m0-5l-4 5" />
      )}
    </svg>
  );
}

export default SoundIcon;
